import { DateTime } from "luxon";
import store from "@/store";
import mixin from "@/utils/global-mixin";

function formatLanguage(locale) {
  let lang;
  if (locale) {
    const converted = locale.replaceAll("_", "-");
    const langArr = converted.split("-");
    lang = langArr.length > 1 ? `${langArr[0]}-${langArr[1]}` : langArr[0];
  }
  return lang || navigator.language;
}

function getMessageText(msg) {
  return mixin.methods.getMessageText(msg);
}

class DateUtil {
  // References:
  // https://moment.github.io/luxon/docs/manual/formatting.html
  // https://moment.github.io/luxon/docs/class/src/datetime.js~DateTime.html

  constructor() {
    this.INVALID_DATE = "Invalid DateTime";
    this.shortDateTimeStyleOptions = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit"
    };
    this.shortDateStyleOptions = {
      year: "numeric",
      month: "numeric",
      day: "numeric"
    };
  }
  fromISO(dateStr) {
    return DateTime.fromISO(dateStr);
  }

  isValidISO(dateStr) {
    return dateStr && dateStr.length > 9
      ? this.fromISO(dateStr).toISO() !== null
      : false;
  }

  toISODate(dateStr) {
    return this.fromISO(dateStr).toISODate();
  }

  toISO(dateStr) {
    return this.fromISO(dateStr).toISO();
  }

  getUnitOptions() {
    return [
      {
        value: "days",
        name: getMessageText(store.state.messages.DATE_UNIT_DAYS),
        dataType: "date"
      },
      {
        value: "weeks",
        name: getMessageText(store.state.messages.DATE_UNIT_WEEKS),
        dataType: "date"
      },
      {
        value: "months",
        name: getMessageText(store.state.messages.DATE_UNIT_MONTHS),
        dataType: "date"
      },
      {
        value: "years",
        name: getMessageText(store.state.messages.DATE_UNIT_YEARS),
        dataType: "date"
      }
    ];
  }

  formatDateTimeFromISO(dateStr, userLocale, userTimeZone) {
    return this.fromISO(dateStr)
      .setLocale(formatLanguage(userLocale))
      .setZone(userTimeZone)
      .toLocaleString(DateTime.DATETIME_SHORT);
  }
}

export default new DateUtil();
